// Plantillas del widget del buscador de renfeviajes.
//
// GENERADO por scripts/f1-widget/generar-markup.js desde
// clases/Modulos/Core/Elementos/BuscadorDestinos/portadaRenfeViajes#buscadorDestinos.tpl
// (y los dos modales de pasajeros del tren + coche, desde buscadorTrenCoches#buscadorDestinos.tpl)
// No editar a mano mientras la home siga usando la plantilla Smarty: en F7 el buscador de la
// home pasa a ser este widget, y entonces este fichero se convierte en la única fuente.

// Los marcadores que deja el generador y que resuelve el runtime al montar:
//   {{12345}}        un texto: textos.js dice cuál, y con qué texto por defecto
//   {{svg:flecha1}}  uno de los dos dibujos de abajo
//   data-rvb="x"     el gancho por el que el runtime encuentra el nodo (sustituye a los id)
//   data-rvb-for     el for= de una etiqueta, que el runtime prefija con el id de instancia
//   data-rvb-name    lo mismo para el name= de los radios

export const svgs = {
  // 33 usos en la plantilla actual
  flecha: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"3.3173mm\" height=\"6.6346mm\" version=\"1.1\" style=\"shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd\" viewBox=\"0 0 3.43 6.87\" aria-hidden=\"true\" focusable=\"false\"><g><path d=\"M3.29 3.92l-1.68 2.55c-0.17,0.27 -0.41,0.41 -0.73,0.41 -0.18,0 -0.34,-0.05 -0.48,-0.14 -0.26,-0.18 -0.4,-0.42 -0.4,-0.74 0,-0.18 0.05,-0.34 0.15,-0.48l1.32 -2.02c0.02,-0.03 0.02,-0.07 -0,-0.11l-1.32 -2.01c-0.1,-0.15 -0.15,-0.32 -0.15,-0.49 0,-0.31 0.13,-0.55 0.4,-0.73 0.14,-0.1 0.3,-0.14 0.48,-0.14 0.32,0 0.56,0.13 0.73,0.4l1.68 2.56c0.1,0.14 0.14,0.3 0.14,0.48 0,0.18 -0.05,0.34 -0.14,0.48z\"></path></g></svg>",
  // 2 usos en la plantilla actual
  tick: "<svg height=\"1.27mm\" style=\"shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd\" viewBox=\"0 0 1.45 1.25\" width=\"1.4765mm\" xmlns=\"http://www.w3.org/2000/svg\" aria-hidden=\"true\" focusable=\"false\"><g><path d=\"M1.4 0.07l-0.04 -0.03c-0.06,-0.06 -0.16,-0.05 -0.22,0.01l-0.65 0.72 -0.2 -0.17c-0.06,-0.06 -0.16,-0.05 -0.22,0.01l-0.03 0.04c-0.03,0.03 -0.04,0.07 -0.04,0.11 0,0.04 0.02,0.08 0.05,0.11l0.36 0.33c0.03,0.03 0.07,0.04 0.12,0.04 0.04,-0 0.08,-0.02 0.11,-0.05l0.78 -0.9c0.03,-0.03 0.04,-0.07 0.04,-0.11 -0,-0.04 -0.02,-0.08 -0.05,-0.11z\"></path></g></svg>",
  // 1 uso en la plantilla actual
  iconoHabitacion: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"60px\" height=\"20px\" version=\"1.1\" style=\"shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd\" viewBox=\"0 0 69000 35999\" aria-hidden=\"true\" focusable=\"false\"><g><metadata></metadata><path style=\"fill:#555555\" d=\"M65752 22582l-11070 -4c-1137,-43 -971,207 -1246,-494l1 -4099c1305,-192 6932,-217 8160,43 1886,401 3874,2584 4155,4554zm-42224 -4696c208,413 55,-418 248,659l-113 3871c-1136,56 -15213,-76 -16405,25l10 -4830 16260 275zm-12090 -10734l-2566 -58 -18 7453c-75,469 -132,397 -249,605l-1330 2c0,-2800 628,-11730 -723,-13463 -1003,-1286 -3340,-1876 -4959,-546 -1637,1344 -1247,3433 -1246,5949 4,9502 0,19006 0,28509l6928 0 -533 -1865c18140,0 36280,0 54421,0l0 1800 7395 71c0,-4347 728,-13252 -1183,-16405 -3493,-5760 -10051,-3457 -13939,-4131 -129,-2434 -1252,-1785 -6461,-1785 -5820,0 -16014,-215 -21328,-13 -2266,85 -1249,986 -2386,1878l-3197 0c-1377,-318 -44,-2215 -3061,-5267 -1242,-1254 -3152,-2666 -5565,-2734z\"></path></g></svg>",
}

export const plantillas = {
  envoltura: `
<div data-rvb="buscador_container">
  <div class="rvb-buscador_completo rvb-buscador_trenHotel rvb-oculto" data-rvb="buscadorDestinosRenfe">
    <div class="rvb-subcontenedorHome">
      <div class="rvb-bloque_carrusel">
        {{pestanas}}
        
        <div data-rvb="form">{{bloques}}</div>
      </div>
    </div>
  </div>
</div>
`,

  pestanas: `
<div class="rvb-topbar-container">
  <div class="rvb-topbar_buscador_carrusel">
    <div class="rvb-tab rvb-tab_selected" data-rvb="tab_paquetetren">
      <span class="rvb-radio-tab">
      </span>
      <span>{{7331}}</span>
    </div>
    <div class="rvb-tab" data-rvb="tab_trenhotelactividad">
      <span class="rvb-radio-tab">
      </span>
      <span>{{1479751}}</span>
    </div>
    <div class="rvb-tab" data-rvb="tab_hotel">
      <span class="rvb-radio-tab">
      </span>
      <span>{{147090}}</span>
    </div>
    <div class="rvb-tab" data-rvb="tab_coche_alquiler">
      <span class="rvb-radio-tab">
      </span>
      <span>{{7386}}</span>
    </div>
    <div class="rvb-tab" data-rvb="tab_actividades">
      <span class="rvb-radio-tab">
      </span>
      <span>{{24560}}</span>
    </div>
  </div>
</div>
`,

  bloquePaqueteTren: `
<div class="rvb-bloque-buscador" data-rvb="bloquePaqueteTren">
  <div class="rvb-bloque_content">
    <div class="rvb-bloque-estaciones">
      <div class="rvb-contenedor-estacion">
        <label class="rvb-form-label" data-rvb="estacionOrigenLabelTA" data-rvb-for="estacionOrigen">
          <button aria-label="Cerrar estación origen" class="rvb-rf-ico rvb-icon-back">
          </button>
          <span class="rvb-label-text">{{416}}</span>
          <input type="text" class="rvb-form-control rvb-input_buscador rvb-buscador rvb-buscadorOrigenOcioTren rvb-station1Input" placeholder="{{7236}}" autocomplete="off" data-rvb="estacionOrigenTrenActividad">
        </label>
        <p class="rvb-error-text">
          {{7238}}
        </p>
      </div>
      <div class="rvb-contenedor-estacion">
        <label class="rvb-form-label" data-rvb="estacionDestinoLabelTA" data-rvb-for="estacionDestino">
          <button aria-label="Cerrar estación destino" class="rvb-rf-ico rvb-icon-back">
          </button>
          <span class="rvb-label-text">{{20808}}</span>
          <input type="text" class="rvb-form-control rvb-input_buscador rvb-buscador rvb-buscadorDestinoOcioTren rvb-station2Input" placeholder="{{7237}}" autocomplete="off" data-rvb="estacionDestinoTrenActividad">
        </label>
        <p class="rvb-error-text">
          {{7238}}
        </p>
      </div>
    </div>
    <div class="rvb-bloque-opciones-busqueda">
      <div class="rvb-datePicker-inputs rvb-input-daterange">
        <label class="rvb-form-label" data-rvb-for="fechaEntrada">
          <i class="rvb-rf-daterange__calendar-ico rvb-rf-ico rvb-icon-calendar">
          </i>
          <input type="text" readonly="readonly" autocomplete="off" class="rvb-form-control rvb-input_buscador rvb-dateUserFrom rvb-date1Input" placeholder="..." data-rvb="fechaEntrada">
          <button class="rvb-btn-cambiar-dias rvb-btn-restar rvb-btn-restar-dia-entrada">
            {{svg:flecha}}
          </button>
          <button class="rvb-btn-cambiar-dias rvb-btn-sumar rvb-btn-sumar-dia-entrada">
            {{svg:flecha}}
          </button>
        </label>
        <label class="rvb-form-label" data-rvb-for="fechaSalida">
          <input type="text" readonly="readonly" autocomplete="off" class="rvb-form-control rvb-input_buscador rvb-dateUserTo rvb-date2Input" placeholder="..." data-rvb="fechaSalida">
          <button class="rvb-btn-cambiar-dias rvb-btn-restar rvb-btn-restar-dia-salida">
            {{svg:flecha}}
          </button>
          <button class="rvb-btn-cambiar-dias rvb-btn-sumar rvb-btn-sumar-dia-salida">
            {{svg:flecha}}
          </button>
        </label>
        <input type="text" readonly="readonly" autocomplete="off" class="rvb-form-control rvb-input_buscador rvb-dateUserFrom rvb-date1Input rvb-dateInputHide" placeholder="{{1479756}}">
        <input type="text" readonly="readonly" autocomplete="off" class="rvb-form-control rvb-input_buscador rvb-dateUserTo rvb-date2Input rvb-dateInputHide" placeholder="{{1479757}}">
      </div>
      <div class="rvb-datePicker-inputs rvb-solo-ida rvb-oculto">
        <label class="rvb-form-label" data-rvb-for="fechaEntrada">
          <i class="rvb-rf-daterange__calendar-ico rvb-rf-ico rvb-icon-calendar">
          </i>
          <input type="text" readonly="readonly" autocomplete="off" class="rvb-form-control rvb-input_buscador rvb-dateUserFrom rvb-date1Input" placeholder="..." data-rvb="fechaEntrada">
          <button class="rvb-btn-cambiar-dias rvb-btn-restar rvb-btn-restar-dia-solo-entrada">
            {{svg:flecha}}
          </button>
          <button class="rvb-btn-cambiar-dias rvb-btn-sumar rvb-btn-sumar-dia-solo-entrada">
            {{svg:flecha}}
          </button>
        </label>
        <label class="rvb-form-label" data-rvb-for="fechaSalida">
          <input type="text" readonly="readonly" autocomplete="off" class="rvb-form-control rvb-input_buscador rvb-dateUserTo rvb-date2Input" placeholder="{{46615}}" value="{{46615}}" data-rvb="fechaSalida">
          <button disabled="" class="rvb-btn-cambiar-dias rvb-btn-restar rvb-btn-restar-dia-salida">
            {{svg:flecha}}
          </button>
          <button disabled="" class="rvb-btn-cambiar-dias rvb-btn-sumar rvb-btn-sumar-dia-salida">
            {{svg:flecha}}
          </button>
        </label>
        <input type="text" readonly="readonly" autocomplete="off" class="rvb-form-control rvb-input_buscador rvb-dateUserFrom rvb-date1Input rvb-dateInputHide" placeholder="{{1479756}}">
        <input type="text" readonly="readonly" autocomplete="off" class="rvb-form-control rvb-input_buscador rvb-dateUserTo rvb-date2Input rvb-dateInputHide" placeholder="{{1479757}}">
      </div>
      <div class="rvb-datepicker-container">
        <div class="rvb-datepicker-ida-vuelta">
        </div>
        <div class="rvb-datepicker-solo-ida rvb-oculto">
        </div>
        <div class="rvb-botones-datepicker rvb-space-between">
          <div class="rvb-contenedor-ida-vuelta">
            <div class="rvb-form-check">
              <input type="radio" class="rvb-checkbox rvb-oculto" value="soloIda" autocomplete="off" data-rvb="radioIdaPaqueteTren" data-rvb-name="radioIdaVueltaPaqueteTren">
              <label class="rvb-form-check-label" data-rvb-for="radioIdaPaqueteTren">
                <span class="rvb-checkmark">
                </span>
                {{344623}}
              </label>
            </div>
            <div class="rvb-form-check">
              <input type="radio" class="rvb-checkbox rvb-oculto" value="idaVuelta" checked="" autocomplete="off" data-rvb="radioIdaVueltaPaqueteTren" data-rvb-name="radioIdaVueltaPaqueteTren">
              <label class="rvb-form-check-label" data-rvb-for="radioIdaVueltaPaqueteTren">
                <span class="rvb-checkmark">
                </span>
                {{87088}}
              </label>
            </div>
          </div>
          <button class="rvb-btn-aceptar-fechas">{{46630}}</button>
          <button class="rvb-btn-aceptar-fechas rvb-mobile">
            {{24851}}
            {{svg:flecha}}
          </button>
        </div>
      </div>
      <button class="rvb-btn-buscar rvb-btn-abrir-swal" disabled="" data-rvb="btnBuscar">
        <span>
          {{7244}}
        </span>
        {{svg:flecha}}
      </button>
    </div>
  </div>
</div>
`,

  bloqueTrenHotelActividad: `
<div class="rvb-bloque-buscador rvb-oculto" data-rvb="bloqueTrenHotelActividad">
  <div class="rvb-bloque_content">
    <div class="rvb-bloque-estaciones">
      <div class="rvb-contenedor-estacion">
        <label class="rvb-form-label" data-rvb="estacionOrigenLabel" data-rvb-for="estacionOrigen">
          <button aria-label="Cerrar estación origen" class="rvb-rf-ico rvb-icon-back">
          </button>
          <span class="rvb-label-text">{{416}}</span>
          <input type="text" class="rvb-form-control rvb-input_buscador rvb-buscador rvb-buscadorOrigenOcioTren rvb-station1Input" placeholder="{{7236}}" autocomplete="off" data-rvb="estacionOrigenTrenHotelActividad">
        </label>
        <p class="rvb-error-text">
          {{7238}}
        </p>
      </div>
      <div class="rvb-contenedor-estacion">
        <label class="rvb-form-label" data-rvb="estacionDestinoLabel" data-rvb-for="estacionDestino">
          <button aria-label="Cerrar estación destino" class="rvb-rf-ico rvb-icon-back">
          </button>
          <span class="rvb-label-text">{{20808}}</span>
          <input type="text" class="rvb-form-control rvb-input_buscador rvb-buscador rvb-buscadorDestinoOcioTren rvb-station2Input" placeholder="{{7237}}" autocomplete="off" data-rvb="estacionDestinoTrenHotelActividad">
        </label>
        <p class="rvb-error-text">
          {{7238}}
        </p>
      </div>
    </div>
    <div class="rvb-bloque-opciones-busqueda">
      <div class="rvb-fila-top-busqueda">
        <button aria-label="Cerrar calendario ida y vuelta" class="rvb-daterange-cerrar rvb-rf-ico rvb-icon-back">
        </button>
        <p class="rvb-fecha-hoy">
        </p>
        <div class="rvb-menu-ida-vuelta rvb-menu-busqueda">
          <button type="button" class="rvb-btn-ida-vuelta rvb-btn-menu">
            <span>{{45898}}
              {{svg:flecha}}
            </span>
            <span class="rvb-oculto">{{45897}}
              {{svg:flecha}}
            </span>
          </button>
          <div class="rvb-menu-desplegable rvb-ida-vuelta-desplegable">
            <div class="rvb-content-menu-desplegable">
              <div class="rvb-body-menu-desplegable">
                <div class="rvb-form-check">
                  <input type="radio" class="rvb-checkbox rvb-oculto" value="soloIda" checked="" autocomplete="off" data-rvb="radioIdaTrenHotelActividad" data-rvb-name="radioIdaVueltaTrenHotelActividad">
                  <label class="rvb-form-check-label" data-rvb-for="radioIdaTrenHotelActividad">
                    {{45897}}
                  </label>
                  {{svg:tick}}
                </div>
                <div class="rvb-form-check">
                  <input type="radio" class="rvb-checkbox rvb-oculto" value="idaVuelta" autocomplete="off" data-rvb="radioIdaVueltaTrenHotelActividad" data-rvb-name="radioIdaVueltaTrenHotelActividad">
                  <label class="rvb-form-check-label" data-rvb-for="radioIdaVueltaTrenHotelActividad">
                    {{45898}}
                  </label>
                  {{svg:tick}}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="rvb-menu-pasajeros rvb-menu-busqueda">
          <input type="hidden" value="1" data-rvb="roomInputHidden">
          <button type="button" class="rvb-btn-pasajeros rvb-btn-menu">
            <span>
              <span class="rvb-resumen-pasajeros">{{25953}}</span>
              {{svg:flecha}}
            </span>
          </button>
          <div class="rvb-menu-desplegable rvb-pasajeros-desplegable">
            <div class="rvb-content-menu-desplegable">
              <div class="rvb-body-menu-desplegable">
                <div class="rvb-buscador-rooms rvb-selectores-pasajeros">
                  <div data-rvb="tren_hotel_hotel_info">
                    <div class="rvb-input rvb-habitaciones">
                      <label>{{24642}}:</label>
                      <div class="rvb-pasajeros-input">
                        <button type="button" disabled="" data-rvb="btnSubtractRoom">
                          <span>-</span>
                        </button>
                        <span class="rvb-hotelNumRooms">1</span>
                        <button type="button" data-rvb="btnAddRoom">
                          <span>+</span>
                        </button>
                        <input type="hidden" class="rvb-hotelNumRooms rvb-buscadorHabitaciones" min="1" max="4" value="1" data-rvb-name="roomCount">
                      </div>
                    </div>
                  </div>
                  <div class="rvb-roomsContent">
                  </div>
                </div>
                
                <div class="rvb-botones-pasajeros">
                  <button type="button" class="rvb-btn-cancelar rvb-btn-cancelar-pasajeros">
                    <span>{{46510}}</span>
                  </button>
                  <button type="button" class="rvb-btn-listo rvb-btn-listo-pasajeros">
                    <span>{{7242}}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="rvb-datePicker-inputs rvb-input-daterange">
        <label class="rvb-form-label" data-rvb-for="fechaEntrada">
          <i class="rvb-rf-daterange__calendar-ico rvb-rf-ico rvb-icon-calendar">
          </i>
          <input type="text" readonly="readonly" class="rvb-form-control rvb-input_buscador rvb-dateUserFrom rvb-date1Input" placeholder="..." data-rvb="fechaEntrada">
          <button class="rvb-btn-cambiar-dias rvb-btn-restar rvb-btn-restar-dia-entrada">
            {{svg:flecha}}
          </button>
          <button class="rvb-btn-cambiar-dias rvb-btn-sumar rvb-btn-sumar-dia-entrada">
            {{svg:flecha}}
          </button>
        </label>
        <label class="rvb-form-label" data-rvb-for="fechaSalida">
          <input type="text" readonly="readonly" class="rvb-form-control rvb-input_buscador rvb-dateUserTo rvb-date2Input" placeholder="..." data-rvb="fechaSalida">
          <button class="rvb-btn-cambiar-dias rvb-btn-restar rvb-btn-restar-dia-salida">
            {{svg:flecha}}
          </button>
          <button class="rvb-btn-cambiar-dias rvb-btn-sumar rvb-btn-sumar-dia-salida">
            {{svg:flecha}}
          </button>
        </label>
        <button class="rvb-btn-borrar-fechas">
          {{7243}}
        </button>
        
        <input type="text" readonly="readonly" class="rvb-form-control rvb-input_buscador rvb-dateUserFrom rvb-date1Input rvb-dateInputHide" placeholder="{{1479756}}">
        <input type="text" readonly="readonly" class="rvb-form-control rvb-input_buscador rvb-dateUserTo rvb-date2Input rvb-dateInputHide" placeholder="{{1479757}}">
      </div>
      <div class="rvb-datepicker-container">
        <div class="rvb-datepicker-ida-vuelta">
        </div>
        <div class="rvb-botones-datepicker">
          <button class="rvb-btn-borrar-fechas rvb-oculto">
            {{7243}}
          </button>
          <button class="rvb-btn-aceptar-fechas">{{46630}}</button>
        </div>
      </div>
      
    </div>
    <button class="rvb-btn-buscar" disabled="" data-rvb="btnBuscar">
      <span>
        {{7244}}
      </span>
      {{svg:flecha}}
    </button>
  </div>
</div>
`,

  bloqueHotel: `
<div class="rvb-bloque-buscador rvb-oculto" data-rvb="bloqueHotel">
  <div class="rvb-bloque_content">
    <div class="rvb-bloque-estaciones rvb-bloque-hotel">
      <div class="rvb-contenedor-estacion">
        <label class="rvb-form-label" data-rvb-for="ciudadDestino">
          <button aria-label="Cerrar ciudad destino" class="rvb-rf-ico rvb-icon-back">
          </button>
          <span class="rvb-label-text">{{41044}}</span>
          <input type="text" class="rvb-form-control rvb-input_buscador rvb-buscador rvb-buscadorDestinoOcioTren rvb-station2Input" placeholder="{{46641}}" autocomplete="off" data-rvb="ciudadDestino">
        </label>
        <p class="rvb-error-text">
          {{7259}}
        </p>
      </div>
      
      <div class="rvb-datePicker-inputs rvb-input-daterange">
        <label class="rvb-form-label" data-rvb-for="fechaEntrada">
          <i class="rvb-rf-daterange__calendar-ico rvb-rf-ico rvb-icon-calendar">
          </i>
          <input type="text" readonly="readonly" class="rvb-form-control rvb-input_buscador rvb-dateUserFrom rvb-date1Input" placeholder="..." data-rvb="fechaEntrada">
          <button class="rvb-btn-cambiar-dias rvb-btn-restar rvb-btn-restar-dia-entrada">
            {{svg:flecha}}
          </button>
          <button class="rvb-btn-cambiar-dias rvb-btn-sumar rvb-btn-sumar-dia-entrada">
            {{svg:flecha}}
          </button>
        </label>
        <label class="rvb-form-label" data-rvb-for="fechaSalida">
          <input type="text" readonly="readonly" class="rvb-form-control rvb-input_buscador rvb-dateUserTo rvb-date2Input" placeholder="..." data-rvb="fechaSalida">
          <button class="rvb-btn-cambiar-dias rvb-btn-restar rvb-btn-restar-dia-salida">
            {{svg:flecha}}
          </button>
          <button class="rvb-btn-cambiar-dias rvb-btn-sumar rvb-btn-sumar-dia-salida">
            {{svg:flecha}}
          </button>
        </label>
        <button class="rvb-btn-borrar-fechas">
          {{7243}}
        </button>
        
        <input type="text" readonly="readonly" class="rvb-form-control rvb-input_buscador rvb-dateUserFrom rvb-date1Input rvb-dateInputHide" placeholder="{{1479756}}">
        <input type="text" readonly="readonly" class="rvb-form-control rvb-input_buscador rvb-dateUserTo rvb-date2Input rvb-dateInputHide" placeholder="{{1479757}}">
      </div>
      <div class="rvb-datepicker-container">
        <div class="rvb-datepicker-ida-vuelta">
        </div>
        <div class="rvb-botones-datepicker">
          <button class="rvb-btn-borrar-fechas rvb-oculto">
            {{7243}}
          </button>
          <button class="rvb-btn-aceptar-fechas">{{46630}}</button>
        </div>
      </div>
    </div>
    
    <div class="rvb-bloque-opciones-busqueda">
      <div class="rvb-fila-top-busqueda">
        <button aria-label="Cerrar calendario ida y vuelta" class="rvb-daterange-cerrar rvb-rf-ico rvb-icon-back">
        </button>
        <p class="rvb-fecha-hoy">
        </p>
        <div class="rvb-menu-pasajeros rvb-menu-busqueda">
          <input type="hidden" value="1" data-rvb="roomInputHidden">
          <button type="button" class="rvb-btn-pasajeros rvb-btn-menu">
            <span>
              <span class="rvb-resumen-pasajeros">{{25953}}</span>
              {{svg:flecha}}
            </span>
          </button>
          <div class="rvb-menu-desplegable rvb-pasajeros-desplegable">
            <div class="rvb-content-menu-desplegable">
              <div class="rvb-body-menu-desplegable">
                <div class="rvb-buscador-rooms rvb-selectores-pasajeros">
                  <div data-rvb="tren_hotel_hotel_info">
                    <div class="rvb-input rvb-habitaciones">
                      <label>{{24642}}:</label>
                      <div class="rvb-pasajeros-input">
                        <button type="button" disabled="" data-rvb="btnSubtractRoom">
                          <span>-</span>
                        </button>
                        <span class="rvb-hotelNumRooms">1</span>
                        <button type="button" data-rvb="btnAddRoom">
                          <span>+</span>
                        </button>
                        <input type="hidden" class="rvb-hotelNumRooms rvb-buscadorHabitaciones" min="1" max="4" value="1" data-rvb-name="roomCount">
                      </div>
                    </div>
                  </div>
                  <div class="rvb-roomsContent">
                  </div>
                </div>
                
                <div class="rvb-botones-pasajeros">
                  <button type="button" class="rvb-btn-cancelar rvb-btn-cancelar-pasajeros">
                    <span>{{46510}}</span>
                  </button>
                  <button type="button" class="rvb-btn-listo rvb-btn-listo-pasajeros">
                    <span>{{7242}}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button class="rvb-btn-buscar" disabled="" data-rvb="btnBuscar">
      <span>
        {{7249}}
      </span>
      {{svg:flecha}}
    </button>
  </div>
</div>
`,

  bloqueActividades: `
<div class="rvb-bloque-buscador rvb-oculto" data-rvb="bloqueActividades">
  <div class="rvb-bloque_content">
    <div class="rvb-bloque-buscador-actividades">
      <div class="rvb-loader">
      </div>
      <div class="rvb-contenedor-buscador rvb-oculto">
        <label class="rvb-form-label" data-rvb-for="buscadorActividades">
          <span class="rvb-label-text">{{7248}}</span>
          <input type="text" class="rvb-form-control rvb-input_buscador rvb-buscador rvb-buscadorDestinoOcioTren rvb-station2Input" placeholder="{{7247}}" autocomplete="off" data-rvb="buscadorActividades">
        </label>
      </div>
    </div>
  </div>
</div>
`,

  swalHotel: `
<div>
  <div class="rvb-contenido">
    <span class="rvb-swal-titulo">{{7336}}</span>
    <button class="rvb-btn-confirm">
      {{20766}}
      {{svg:flecha}}
    </button>
    <button class="rvb-btn-deny">
      {{7337}}
      {{svg:flecha}}
    </button>
  </div>
</div>
`,

  menuPasajerosTrenOcio: `
<div>
  <div class="rvb-menu-pasajeros rvb-menu-busqueda">
    <div data-rvb="menuPasajerosTrenOcio">
      <div class="rvb-menu-desplegable rvb-pasajeros-desplegable">
        <h4 class="rvb-titulo">{{7338}}</h4>
          <div class="rvb-content-menu-desplegable">
            <div class="rvb-body-menu-desplegable">
              <div class="rvb-selectores-pasajeros">
                <div class="rvb-m-auto rvb-lista-pasajeros">
                  <div class="rvb-input">
                    <label>
                      <span>{{25942}}</span>
                      <span>{{7339}}</span>
                    </label>
                    <div class="rvb-pasajeros-input">
                      <button type="button" class="rvb-btn-subtract">
                        <span>-</span>
                      </button>
                      <span class="rvb-num-adults">1</span>
                      <button type="button" class="rvb-btn-add">
                        <span>+</span>
                      </button>
                      <input type="hidden" class="rvb-adultsInput rvb-adultsAmount" min="1" max="9" value="1">
                    </div>
                  </div>
                  <div class="rvb-input">
                    <label>
                      <span>{{7239}}</span>
                      <span>{{7340}}</span>
                    </label>
                    <div class="rvb-pasajeros-input">
                      <button type="button" class="rvb-btn-subtract" disabled="">
                        <span>-</span>
                      </button>
                      <span class="rvb-num-children">0</span>
                      <button type="button" class="rvb-btn-add">
                        <span>+</span>
                      </button>
                      <input type="hidden" class="rvb-childrenInput rvb-childrenAmount" min="0" max="8" value="0">
                    </div>
                  </div>
                  <div class="rvb-input">
                    <label>
                      <span>{{7240}}</span>
                      <span>{{7341}}</span>
                    </label>
                    <div class="rvb-pasajeros-input">
                      <button type="button" class="rvb-btn-subtract" disabled="">
                        <span>-</span>
                      </button>
                      <span class="rvb-num-babies">0</span>
                      <button type="button" class="rvb-btn-add">
                        <span>+</span>
                      </button>
                      <input type="hidden" class="rvb-childrenInput rvb-babiesAmount" min="0" max="1" value="0">
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="rvb-botones-pasajeros">
                <button type="button" class="rvb-btn-listo rvb-btn-listo-pasajeros">
                  <span>{{46629}}</span>
                  {{svg:flecha}}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
`,

  menuPasajerosTrenHotel: `
<div>
  <div class="rvb-menu-pasajeros rvb-menu-busqueda">
    <div data-rvb="menuPasajerosTrenHotel">
      <div class="rvb-menu-desplegable rvb-pasajeros-desplegable">
        <h4 class="rvb-titulo">{{7338}}</h4>
          <div class="rvb-content-menu-desplegable">
            <div class="rvb-body-menu-desplegable">
              <div class="rvb-buscador-rooms rvb-selectores-pasajeros">
                <div data-rvb="tren_hotel_hotel_info">
                  <div class="rvb-input rvb-habitaciones">
                    <label>{{24642}}:</label>
                    <div class="rvb-pasajeros-input">
                      <button type="button" disabled="" data-rvb="btnSubtractRoom">
                        <span>-</span>
                      </button>
                      <span class="rvb-hotelNumRooms">1</span>
                      <button type="button" data-rvb="btnAddRoom">
                        <span>+</span>
                      </button>
                      <input type="hidden" class="rvb-hotelNumRooms rvb-buscadorHabitaciones" min="1" max="4" value="1" data-rvb-name="roomCount">
                    </div>
                  </div>
                </div>
                <div class="rvb-roomsContent">
                  <div class="rvb-room rvb-lista-pasajeros">
                    <span class="rvb-span_habitacion">
                      {{24643}} <span class="rvb-roomNumber">1</span>
                    </span>
                    <div class="rvb-input">
                      <label>
                        <span>{{25942}}</span>
                        <span>{{7339}}</span>
                      </label>
                      <div class="rvb-pasajeros-input">
                        <button type="button" class="rvb-btn-subtract">
                          <span>-</span>
                        </button>
                        <span class="rvb-num-adults">2</span>
                        <button type="button" class="rvb-btn-add">
                          <span>+</span>
                        </button>
                        <input type="hidden" class="rvb-adultsInput rvb-hotelNumPeople rvb-hotelPeopleData rvb-adultsAmount" min="1" max="4" value="2">
                      </div>
                    </div>
                    <div class="rvb-input-hotel">
                      <div class="rvb-input">
                        <label>
                          <span>{{7239}}</span>
                          <span>{{7340}}</span>
                        </label>
                        <div class="rvb-pasajeros-input rvb-bloqueNinosHotel">
                          <button type="button" class="rvb-btn-subtract rvb-ninosHotel" data-hab="1" disabled="">
                            <span>-</span>
                          </button>
                          <span class="rvb-num-children">0</span>
                          <button type="button" class="rvb-btn-add rvb-ninosHotel" data-hab="1">
                            <span>+</span>
                          </button>
                          <input type="hidden" class="rvb-childrenInput rvb-hotelChildrenInput rvb-hotelNumPeople rvb-hotelPeopleData rvb-childrenAmount" min="0" max="4" value="0">
                        </div>
                      </div>
                      
                      <div data-rvb="inputs-edades-hotel">
                      </div>
                    </div>
                    <div class="rvb-input-tren">
                      <div class="rvb-input">
                        <label>
                          <span>{{7240}}</span>
                          <span>{{7341}}</span>
                        </label>
                        <div class="rvb-pasajeros-input rvb-bloqueNinosTren">
                          <button type="button" class="rvb-btn-subtract rvb-ninosTren" data-hab="1" disabled="">
                            <span>-</span>
                          </button>
                          <span class="rvb-num-babies">0</span>
                          <button type="button" class="rvb-btn-add rvb-ninosTren" data-hab="1">
                            <span>+</span>
                          </button>
                          <input type="hidden" class="rvb-childrenInput rvb-hotelChildrenInput rvb-hotelNumPeople rvb-hotelPeopleData rvb-babiesAmount" min="0" max="2" value="0">
                        </div>
                      </div>
                      
                      <div data-rvb="inputs-edades-tren-hotel">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="rvb-botones-pasajeros">
                <button type="button" class="rvb-btn-listo rvb-btn-listo-pasajeros">
                  <span>{{46629}}</span>
                  {{svg:flecha}}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <input type="hidden" value="1" data-rvb="roomInputHidden">
    </div>
  </div>
`,

  calendarioSalidaHotel: `
<div>
  <div class="rvb-contenido">
    <div data-rvb="form">
      <div data-rvb="bloqueFechasHotel">
        <h4 class="rvb-titulo">{{25967}}</h4>
          <div class="rvb-datePicker-inputs rvb-input-daterange">
            <label class="rvb-form-label" data-rvb-for="fechaEntradaHotel">
              <i class="rvb-rf-daterange__calendar-ico rvb-rf-ico rvb-icon-calendar">
              </i>
              <input type="text" readonly="readonly" autocomplete="off" disabled="" class="rvb-form-control rvb-input_buscador rvb-dateUserFrom rvb-date1Input" placeholder="..." data-rvb="fechaEntradaHotel">
            </label>
            <label class="rvb-form-label" data-rvb-for="fechaSalidaHotel">
              <input type="text" readonly="readonly" autocomplete="off" class="rvb-form-control rvb-input_buscador rvb-dateUserTo rvb-date2Input" placeholder="..." data-rvb="fechaSalidaHotel">
              <button class="rvb-btn-cambiar-dias rvb-btn-restar rvb-btn-restar-dia-salida">
                {{svg:flecha}}
              </button>
              <button class="rvb-btn-cambiar-dias rvb-btn-sumar rvb-btn-sumar-dia-salida">
                {{svg:flecha}}
              </button>
            </label>
            <input type="text" readonly="readonly" autocomplete="off" class="rvb-form-control rvb-input_buscador rvb-dateUserFrom rvb-date1Input rvb-dateInputHide" placeholder="{{1479756}}">
            <input type="text" readonly="readonly" autocomplete="off" class="rvb-form-control rvb-input_buscador rvb-dateUserTo rvb-date2Input rvb-dateInputHide" placeholder="{{1479757}}">
          </div>
          <div class="rvb-datepicker-container">
            <div class="rvb-datepicker-ida-vuelta">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="rvb-botones">
      <button class="rvb-btn-aceptar-fechas">{{46630}}</button>
      <button class="rvb-btn-aceptar-fechas rvb-mobile">
        {{24851}}
        {{svg:flecha}}
      </button>
    </div>
  </div>
`,

  calendarioCoche: `
<div>
  <div class="rvb-contenido">
    <div data-rvb="form">
      <div data-rvb="bloqueFechasCoche">
        <h4 class="rvb-titulo">{{2011810}}</h4>
          <div class="rvb-datePicker-inputs rvb-input-daterange">
            <label class="rvb-form-label" data-rvb-for="fechaRecogidaCoche">
              <i class="rvb-rf-daterange__calendar-ico rvb-rf-ico rvb-icon-calendar">
              </i>
              <input type="text" readonly="readonly" autocomplete="off" class="rvb-form-control rvb-input_buscador rvb-dateUserFrom rvb-date1Input" placeholder="..." data-rvb="fechaRecogidaCoche">
            </label>
            <label class="rvb-form-label" data-rvb-for="fechaDevolucionCoche">
              <input type="text" readonly="readonly" autocomplete="off" class="rvb-form-control rvb-input_buscador rvb-dateUserTo rvb-date2Input" placeholder="..." data-rvb="fechaDevolucionCoche">
            </label>
            <input type="text" readonly="readonly" autocomplete="off" class="rvb-form-control rvb-input_buscador rvb-dateUserFrom rvb-date1Input rvb-dateInputHide" placeholder="{{416}}">
            <input type="text" readonly="readonly" autocomplete="off" class="rvb-form-control rvb-input_buscador rvb-dateUserTo rvb-date2Input rvb-dateInputHide" placeholder="{{20808}}">
          </div>
          <div class="rvb-datepicker-container">
            <div class="rvb-datepicker-ida-vuelta">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="rvb-botones">
      <button class="rvb-btn-aceptar-fechas">{{46630}}</button>
      <button class="rvb-btn-aceptar-fechas rvb-mobile">
        {{24851}}
        {{svg:flecha}}
      </button>
    </div>
  </div>
`,

  menuPasajerosTrenCoche: `
<div>
  <div class="rvb-menu-pasajeros rvb-menu-busqueda">
    <div data-rvb="menuPasajerosTrenCoche">
      <div class="rvb-menu-desplegable rvb-pasajeros-desplegable">
        <h4 class="rvb-titulo">{{7338}}</h4>
          <div class="rvb-content-menu-desplegable">
            <div class="rvb-body-menu-desplegable">
              <div class="rvb-selectores-pasajeros">
                <div class="rvb-m-auto rvb-lista-pasajeros">
                  <div class="rvb-input">
                    <label>
                      <span>{{25942}}</span>
                      <span>{{7339}}</span>
                    </label>
                    <div class="rvb-pasajeros-input">
                      <button type="button" class="rvb-btn-subtract">
                        <span>-</span>
                      </button>
                      <span class="rvb-num-adults">1</span>
                      <button type="button" class="rvb-btn-add">
                        <span>+</span>
                      </button>
                      <input type="hidden" class="rvb-adultsInput rvb-adultsAmount" min="1" max="9" value="1">
                    </div>
                  </div>
                  <div class="rvb-input">
                    <label>
                      <span>{{7239}}</span>
                      <span>{{7340}}</span>
                    </label>
                    <div class="rvb-pasajeros-input">
                      <button type="button" class="rvb-btn-subtract" disabled="">
                        <span>-</span>
                      </button>
                      <span class="rvb-num-children">0</span>
                      <button type="button" class="rvb-btn-add">
                        <span>+</span>
                      </button>
                      <input type="hidden" class="rvb-childrenInput rvb-childrenAmount" min="0" max="8" value="0">
                    </div>
                  </div>
                  <div class="rvb-input">
                    <label>
                      <span>{{7240}}</span>
                      <span>{{7341}}</span>
                    </label>
                    <div class="rvb-pasajeros-input">
                      <button type="button" class="rvb-btn-subtract" disabled="">
                        <span>-</span>
                      </button>
                      <span class="rvb-num-babies">0</span>
                      <button type="button" class="rvb-btn-add">
                        <span>+</span>
                      </button>
                      <input type="hidden" class="rvb-childrenInput rvb-babiesAmount" min="0" max="1" value="0">
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="rvb-edad-conductor">
                <div class="rvb-input">
                  <label data-rvb-for="edadConductor">
                    <span>{{7388}}</span>
                  </label>
                  <div class="rvb-pasajeros-input">
                    <select data-rvb="edadConductor" data-rvb-name="edadConductor">
                      <option value="21" selected="">21</option>
                      <option value="22">22</option>
                      <option value="23">23</option>
                      <option value="24">24</option>
                      <option value="25">25</option>
                      <option value="26">26</option>
                      <option value="27">27</option>
                      <option value="28">28</option>
                      <option value="29">29</option>
                      <option value="30">30</option>
                      <option value="31">31</option>
                      <option value="32">32</option>
                      <option value="33">33</option>
                      <option value="34">34</option>
                      <option value="35">35</option>
                      <option value="36">36</option>
                      <option value="37">37</option>
                      <option value="38">38</option>
                      <option value="39">39</option>
                      <option value="40">40</option>
                      <option value="41">41</option>
                      <option value="42">42</option>
                      <option value="43">43</option>
                      <option value="44">44</option>
                      <option value="45">45</option>
                      <option value="46">46</option>
                      <option value="47">47</option>
                      <option value="48">48</option>
                      <option value="49">49</option>
                      <option value="50">50</option>
                      <option value="51">51</option>
                      <option value="52">52</option>
                      <option value="53">53</option>
                      <option value="54">54</option>
                      <option value="55">55</option>
                      <option value="56">56</option>
                      <option value="57">57</option>
                      <option value="58">58</option>
                      <option value="59">59</option>
                      <option value="60">60</option>
                      <option value="61">61</option>
                      <option value="62">62</option>
                      <option value="63">63</option>
                      <option value="64">64</option>
                      <option value="65">65</option>
                      <option value="66">66</option>
                      <option value="67">67</option>
                      <option value="68">68</option>
                      <option value="69">69</option>
                      <option value="70">70</option>
                      <option value="71">71</option>
                      <option value="72">72</option>
                      <option value="73">73</option>
                      <option value="74">74</option>
                      <option value="75">75</option>
                      <option value="76">76</option>
                      <option value="77">77</option>
                      <option value="78">78</option>
                      <option value="79">79</option>
                      <option value="80">80</option>
                      <option value="81">81</option>
                      <option value="82">82</option>
                      <option value="83">83</option>
                      <option value="84">84</option>
                      <option value="85">85</option>
                      <option value="86">86</option>
                      <option value="87">87</option>
                      <option value="88">88</option>
                      <option value="89">89</option>
                      <option value="90">90</option>
                      <option value="91">91</option>
                      <option value="92">92</option>
                      <option value="93">93</option>
                      <option value="94">94</option>
                      <option value="95">95</option>
                      <option value="96">96</option>
                      <option value="97">97</option>
                      <option value="98">98</option>
                      <option value="99">99</option>
                    </select>
                  </div>
                </div>
              </div>
              
              <div class="rvb-botones-pasajeros">
                <button type="button" class="rvb-btn-listo rvb-btn-listo-pasajeros">
                  <span>{{46629}}</span>
                  {{svg:flecha}}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
`,

  menuPasajerosTrenHotelCoche: `
<div>
  <div class="rvb-menu-pasajeros rvb-menu-busqueda">
    <div data-rvb="menuPasajerosTrenHotelCoche">
      <div class="rvb-menu-desplegable rvb-pasajeros-desplegable">
        <h4 class="rvb-titulo">{{7338}}</h4>
          <div class="rvb-content-menu-desplegable">
            <div class="rvb-body-menu-desplegable">
              <div class="rvb-buscador-rooms rvb-selectores-pasajeros">
                <div data-rvb="tren_hotel_hotel_info">
                  <div class="rvb-input rvb-habitaciones">
                    <label>{{24642}}:</label>
                    <div class="rvb-pasajeros-input">
                      <button type="button" disabled="" data-rvb="btnSubtractRoom">
                        <span>-</span>
                      </button>
                      <span class="rvb-hotelNumRooms">1</span>
                      <button type="button" data-rvb="btnAddRoom">
                        <span>+</span>
                      </button>
                      <input type="hidden" class="rvb-hotelNumRooms rvb-buscadorHabitaciones" min="1" max="4" value="1" data-rvb-name="roomCount">
                    </div>
                  </div>
                </div>
                <div class="rvb-roomsContent">
                  <div class="rvb-room rvb-lista-pasajeros">
                    <span class="rvb-span_habitacion">
                      {{24643}} <span class="rvb-roomNumber">1</span>
                    </span>
                    <div class="rvb-input">
                      <label>
                        <span>{{25942}}</span>
                        <span>{{7339}}</span>
                      </label>
                      <div class="rvb-pasajeros-input">
                        <button type="button" class="rvb-btn-subtract">
                          <span>-</span>
                        </button>
                        <span class="rvb-num-adults">2</span>
                        <button type="button" class="rvb-btn-add">
                          <span>+</span>
                        </button>
                        <input type="hidden" class="rvb-adultsInput rvb-hotelNumPeople rvb-hotelPeopleData rvb-adultsAmount" min="1" max="4" value="2">
                      </div>
                    </div>
                    <div class="rvb-input-hotel">
                      <div class="rvb-input">
                        <label>
                          <span>{{7239}}</span>
                          <span>{{7340}}</span>
                        </label>
                        <div class="rvb-pasajeros-input rvb-bloqueNinosHotel">
                          <button type="button" class="rvb-btn-subtract rvb-ninosHotel" data-hab="1" disabled="">
                            <span>-</span>
                          </button>
                          <span class="rvb-num-children">0</span>
                          <button type="button" class="rvb-btn-add rvb-ninosHotel" data-hab="1">
                            <span>+</span>
                          </button>
                          <input type="hidden" class="rvb-childrenInput rvb-hotelChildrenInput rvb-hotelNumPeople rvb-hotelPeopleData rvb-childrenAmount" min="0" max="4" value="0">
                        </div>
                      </div>
                      
                      <div data-rvb="inputs-edades-hotel">
                      </div>
                    </div>
                    <div class="rvb-input-tren">
                      <div class="rvb-input">
                        <label>
                          <span>{{7240}}</span>
                          <span>{{7341}}</span>
                        </label>
                        <div class="rvb-pasajeros-input rvb-bloqueNinosTren">
                          <button type="button" class="rvb-btn-subtract rvb-ninosTren" data-hab="1" disabled="">
                            <span>-</span>
                          </button>
                          <span class="rvb-num-babies">0</span>
                          <button type="button" class="rvb-btn-add rvb-ninosTren" data-hab="1">
                            <span>+</span>
                          </button>
                          <input type="hidden" class="rvb-childrenInput rvb-hotelChildrenInput rvb-hotelNumPeople rvb-hotelPeopleData rvb-babiesAmount" min="0" max="2" value="0">
                        </div>
                      </div>
                      
                      <div data-rvb="inputs-edades-tren-hotel">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="rvb-edad-conductor">
                <div class="rvb-input">
                  <label data-rvb-for="edadConductor">
                    <span>{{7388}}</span>
                  </label>
                  <div class="rvb-pasajeros-input">
                    <select data-rvb="edadConductor" data-rvb-name="edadConductor">
                      <option value="21" selected="">21</option>
                      <option value="22">22</option>
                      <option value="23">23</option>
                      <option value="24">24</option>
                      <option value="25">25</option>
                      <option value="26">26</option>
                      <option value="27">27</option>
                      <option value="28">28</option>
                      <option value="29">29</option>
                      <option value="30">30</option>
                      <option value="31">31</option>
                      <option value="32">32</option>
                      <option value="33">33</option>
                      <option value="34">34</option>
                      <option value="35">35</option>
                      <option value="36">36</option>
                      <option value="37">37</option>
                      <option value="38">38</option>
                      <option value="39">39</option>
                      <option value="40">40</option>
                      <option value="41">41</option>
                      <option value="42">42</option>
                      <option value="43">43</option>
                      <option value="44">44</option>
                      <option value="45">45</option>
                      <option value="46">46</option>
                      <option value="47">47</option>
                      <option value="48">48</option>
                      <option value="49">49</option>
                      <option value="50">50</option>
                      <option value="51">51</option>
                      <option value="52">52</option>
                      <option value="53">53</option>
                      <option value="54">54</option>
                      <option value="55">55</option>
                      <option value="56">56</option>
                      <option value="57">57</option>
                      <option value="58">58</option>
                      <option value="59">59</option>
                      <option value="60">60</option>
                      <option value="61">61</option>
                      <option value="62">62</option>
                      <option value="63">63</option>
                      <option value="64">64</option>
                      <option value="65">65</option>
                      <option value="66">66</option>
                      <option value="67">67</option>
                      <option value="68">68</option>
                      <option value="69">69</option>
                      <option value="70">70</option>
                      <option value="71">71</option>
                      <option value="72">72</option>
                      <option value="73">73</option>
                      <option value="74">74</option>
                      <option value="75">75</option>
                      <option value="76">76</option>
                      <option value="77">77</option>
                      <option value="78">78</option>
                      <option value="79">79</option>
                      <option value="80">80</option>
                      <option value="81">81</option>
                      <option value="82">82</option>
                      <option value="83">83</option>
                      <option value="84">84</option>
                      <option value="85">85</option>
                      <option value="86">86</option>
                      <option value="87">87</option>
                      <option value="88">88</option>
                      <option value="89">89</option>
                      <option value="90">90</option>
                      <option value="91">91</option>
                      <option value="92">92</option>
                      <option value="93">93</option>
                      <option value="94">94</option>
                      <option value="95">95</option>
                      <option value="96">96</option>
                      <option value="97">97</option>
                      <option value="98">98</option>
                      <option value="99">99</option>
                    </select>
                  </div>
                </div>
              </div>
              
              <div class="rvb-botones-pasajeros">
                <button type="button" class="rvb-btn-listo rvb-btn-listo-pasajeros">
                  <span>{{46629}}</span>
                  {{svg:flecha}}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <input type="hidden" value="1" data-rvb="roomInputHidden">
    </div>
  </div>
`,

  habitacion: `
<div>
  <div class="rvb-room rvb-lista-pasajeros">
    <span class="rvb-span_habitacion">
      {{24643}} <span class="rvb-roomNumber">1</span>
    </span>
    <div class="rvb-input">
      <label>{{25942}}</label>
      <div class="rvb-pasajeros-input">
        <button type="button" class="rvb-btn-subtract">
          <span>-</span>
        </button>
        <span class="rvb-num-adults">2</span>
        <button type="button" class="rvb-btn-add">
          <span>+</span>
        </button>
        <input type="hidden" class="rvb-adultsInput rvb-hotelNumPeople rvb-hotelPeopleData rvb-adultsAmount" min="1" max="4" value="2">
      </div>
    </div>
    <div class="rvb-input-hotel">
      <div class="rvb-input">
        <label>{{7239}}</label>
        <div class="rvb-pasajeros-input rvb-bloqueNinosHotel">
          <button type="button" class="rvb-btn-subtract rvb-ninosHotel" data-hab="1" disabled="">
            <span>-</span>
          </button>
          <span class="rvb-num-children">0</span>
          <button type="button" class="rvb-btn-add rvb-ninosHotel" data-hab="1">
            <span>+</span>
          </button>
          <input type="hidden" class="rvb-childrenInput rvb-hotelChildrenInput rvb-hotelNumPeople rvb-hotelPeopleData rvb-childrenAmount" min="0" max="4" value="0">
        </div>
      </div>
      
      <div data-rvb="inputs-edades-hotel">
      </div>
    </div>
    <div class="rvb-input-tren">
      <div class="rvb-input">
        <label>
          <span>
            {{7240}}
          </span>
          <span>
            {{7241}}
          </span>
        </label>
        <div class="rvb-pasajeros-input rvb-bloqueNinosTren">
          <button type="button" class="rvb-btn-subtract rvb-ninosTren" data-hab="1" disabled="">
            <span>-</span>
          </button>
          <span class="rvb-num-babies">0</span>
          <button type="button" class="rvb-btn-add rvb-ninosTren" data-hab="1">
            <span>+</span>
          </button>
          <input type="hidden" class="rvb-childrenInput rvb-hotelChildrenInput rvb-hotelNumPeople rvb-hotelPeopleData rvb-babiesAmount" min="0" max="2" value="0">
        </div>
      </div>
      
      <div data-rvb="inputs-edades-tren-hotel">
      </div>
    </div>
  </div>
  
  
</div>
`,

  habitacionPorDefecto: `
<div class="rvb-roomPorDefecto rvb-oculto">
  {{svg:iconoHabitacion}}
  <span class="rvb-span_habitacion">{{25953}}</span>
  <div class="rvb-input">
    <label>{{24531}}:</label>
    <select class="rvb-span1 rvb-queryValue rvb-peq rvb-adultsInput rvb-hotelNumPeople rvb-hotelPeopleData rvb-adultsAmount">
      <option value="1">1</option>
      <option value="2" selected="">2</option>
      <option value="3">3</option>
      <option value="4">4</option>
    </select>
  </div>
  <div class="rvb-input">
    <label>{{188}}:</label>
    <select class="rvb-span1 rvb-queryValue rvb-peq rvb-childrenInput rvb-hotelChildrenInput rvb-hotelNumPeople rvb-hotelPeopleData rvb-childrenAmount">
      <option value="0">0</option>
      <option value="1">1</option>
      <option value="2">2</option>
      <option value="3">3</option>
      <option value="4">4</option>
    </select>
  </div>
  <div class="rvb-input">
    <label>{{188}}:</label>
    <select class="rvb-span1 rvb-queryValue rvb-peq rvb-childrenInput rvb-hotelChildrenInput rvb-hotelNumPeople rvb-hotelPeopleData rvb-babiesAmount">
      <option value="0">0</option>
      <option value="1">1</option>
      <option value="2">2</option>
      <option value="3">3</option>
      <option value="4">4</option>
    </select>
  </div>
  <div class="rvb-childrenAgesContent rvb-oculto">
    <label>{{24543}}:</label>
    <div class="rvb-selectContent">
    </div>
  </div>
</div>
`,

  cargando: `
<div data-rvb="loadingBuscador" class="rvb-oculto">
  <div class="rvb-loader">
  </div>
</div>
`,

  bookingCampos: `
<div data-rvb="bookingCampos" hidden="hidden">
  <input type="hidden" value="false" data-rvb="launchSEBooking">
  <input type="hidden" value="1649928" data-rvb="SEaid">
  <input type="hidden" value="" data-rvb="SEcheckin">
  <input type="hidden" value="" data-rvb="SEcheckout">
  <input type="hidden" value="city" data-rvb="SEdesttype">
  <input type="hidden" value="" data-rvb="SEdestid">
  <input type="hidden" value="" data-rvb="SEgroupadults">
</div>
`,
}
